import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';
import { DocumentCreateModel, DocumentModel } from '@data-layer/models/documents';
import { enumDocumentState } from '@data-layer/enums/documents';
import { ACCESS_TOKEN, TOKEN_TYPE } from '@constants/setting-keys.const';

@Injectable({
  providedIn: 'root',
})
export class DocumentsCustomsBrokerManagementRepository {
  constructor(private apiService: ApiService) {}

  /** #13415 — create an ES document record (metadata only; the file goes through uploadFile). */
  public create(entrySummaryId: number, document: DocumentCreateModel, isShowLoader: boolean = false): Observable<DocumentModel> {
    return this.apiService.post<DocumentModel>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/entry-summaries/${entrySummaryId}/documents`,
      document,
      null,
      { isShowLoader },
    );
  }

  /** #13415 — multipart file upload for a created document (mirrors DocumentsRepository.uploadFile). */
  public uploadFile(id: number, file: File, isShowLoader: boolean = false): Observable<never> {
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    return this.apiService.post(
      `${environment.url.prefixCustoms}v2/management/customs-broker/documents/${id}/data`,
      formData,
      {
        headers: {
          Authorization: `${localStorage.getItem(TOKEN_TYPE)} ${localStorage.getItem(ACCESS_TOKEN)}`,
        },
      },
      { isShowLoader },
      (error: HttpErrorResponse) => throwError(() => error),
    );
  }

  public getDocumentState(id: number, isShowLoader: boolean = false): Observable<enumDocumentState> {
    return this.apiService.get<enumDocumentState>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/documents/${id}/state`,
      null,
      {
        isShowLoader,
      },
    );
  }

  public delete(id: number, isShowLoader: boolean = false): Observable<never> {
    return this.apiService.delete(`${environment.url.prefixCustoms}v2/management/customs-broker/documents/${id}`, null, { isShowLoader });
  }

  public getEsDocuments(entrySummaryId: number, isShowLoader: boolean = true): Observable<DocumentModel[]> {
    return this.apiService.get<DocumentModel[]>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/entry-summaries/${entrySummaryId}/documents`,
      null,
      { isShowLoader },
    );
  }

  public getDownloadLink(id: number, isShowLoader: boolean = true): Observable<{ downloadUrl: string }> {
    return this.apiService.get<{ downloadUrl: string }>(
      `${environment.url.prefixCustoms}v2/management/customs-broker/documents/${id}/data-url`,
      null,
      { isShowLoader },
    );
  }
}
